module.exports = __webpack_public_path__ + "84b96900cbe08ffac34ccdbce4ec8258.woff";